<template>
  <module-tab name="待结算" enable-flex @mounted="tabHandle" @activated="$refs.table.update()">
    <m-search ref="search" @search="searchHandle">
      <m-search-item label="订单编号">
        <c-input name="order_number"></c-input>
      </m-search-item>
      <m-search-item label="费用名称">
        <c-input name="fee_name"></c-input>
      </m-search-item>
      <m-search-item label="生成时间" colspan="2">
        <c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
      </m-search-item>
    </m-search>

    <div class="total flex-wrap">
      <div class="item flex-between-center flex-grow">
          <label>待结算金额（元）</label>
          <div>{{settlement.settle_amount}}</div>
      </div>
      <div class="item flex-between-center flex-grow">
          <label>待结算商品（件）</label>
          <div>{{settlement.settle_count}}</div>
      </div>
    </div>
    <m-operate>
          <c-button color="m" hollow @click="syncExport()">导出</c-button>
    </m-operate>
    <c-table ref="table" height="grow">
      <c-table-column
          label="订单编号"
          width="130"
          name="order_number"
      >
      </c-table-column>

      <c-table-column
          label="费用名称"
          width="150"
          name="fee_name"
      >
      </c-table-column>

      <c-table-column
          label="商品数量"
          width="130"
      >
        <template #default="{data}">
          {{data.wait_settle_count}}
        </template>
      </c-table-column>

      <c-table-column
          label="金额"
          width="170"
      >
        <template #default="{data}">
          ￥ {{data.wait_settle_amount}}
        </template>
      </c-table-column>

      <c-table-column
          label="生成时间"
          width="170"
          name="create_date"
      ></c-table-column>

      <c-table-column
          type="button"
          label="操作"
          width="170"
      >
        <template #default="{data}">
          <c-table-button v-if="data.fee_code == 1000" @click="detail(data)">查看明细</c-table-button>
        </template>
      </c-table-column>
    </c-table>

    <c-dialog ref="detailDialog" title="结算明细" width="1000" :button="false">
      <c-table ref="detailTable" height="500" >
        <c-table-column
            label="商品信息"
            width="300"
        >
          <template #default="{data}">
            <div class="sku flex-center-cross">
              <c-file media :src="data.product_img_url" style="margin-right: 18px;"></c-file>
              <div class="flex-grow">
                <p class="sku-name ellipsis">{{data.product_name}}</p>
                <p class="sku-spec">{{data.product_sku_spec}}</p>
              </div>
            </div>
          </template>
        </c-table-column>

          <c-table-column
              label="商品单价"
              width="150"
          >
              <template #default="{data}">
                  ￥ {{data.product_unit_price}}
                  <p style="color:brown;" v-if="orderType == 7 && data.custom_unit_price && data.custom_unit_price>0">(含定制费：￥ {{data.custom_unit_price}})</p>
              </template>
          </c-table-column>


          <c-table-column
                label="结算数量"
                width="60"
          >
              <template #default="{data}">
                x {{data.wait_settle_count}}
              </template>
          </c-table-column>


          <c-table-column
                  label="服务费"
                  width="80"
                  v-if="this.public_user_platform_profit_model==1"
          >
              <template #default="{data}">
                  <span style="color:red;">￥ {{data.wait_settle_service_money}}</span>
              </template>
          </c-table-column>

          <c-table-column
                  label="结算金额"
                  width="100"
          >
              <template #default="{data}">
                  ￥ {{data.wait_settle_money}}
              </template>
          </c-table-column>
      </c-table>
    </c-dialog>
  </module-tab>
</template>

<script>
export default {
  data() {
    return {
      workType:22,
      searchParams:{},
      settlement: {},
      orderType:0, //订单类型 7=定制单
      public_user_platform_profit_model:0,//1：向商家抽取服务费，2：加价销售
      settle_state:1  //1=待结算  2=已结算
    }
  },

  methods: {
    tabHandle() {
      this.$refs.search.search();
      this.loadSettlement({});
    },

    searchHandle(data) {
          this.searchParams = Object.assign(data, {
                settle_state: this.settle_state
          });
          this.$refs.table.load({
            url: '/buss/settlement/stationed/list',
            data: this.searchParams
          });
          this.loadSettlement(data);
    },

    loadSettlement(data) {
      this.request({
        url: '/buss/settlement/stationed/total',
        data: Object.assign(data, {
            settle_state: this.settle_state
        }),
        loading: false,  // 是否显示loading，
        success: data => {
          this.settlement = data;
          this.public_user_platform_profit_model = data.public_user_platform_profit_model;
        }
      });
    },

    detail(data) {
        this.orderType = data.order_type;
        this.$refs.detailTable.load({
            url: '/buss/settlement/detail/list',
            data: {
                order_number: data.order_number,
                settle_state: this.settle_state
            }
        });
        this.$refs.detailDialog.open();
    },
    /**同步导出数据**/
    syncExport(){
          this.request({
              url: '/export/url',
              data: Object.assign({
                  work_type: this.workType //业务类型
              },this.searchParams),
              success: data => {
                  this.download({
                      fileName: data.filename,
                      url: data.url,
                      loading: {
                          message: '数据文件生成中...'
                      }
                  })
              }
          });
     }
  }
}
</script>

<style lang="stylus" scoped>
	.total {
		padding: 0 20px 10px;
		
		.item {
			box-sizing: border-box;
			max-width: 530px;
			height: 90px;
			padding: 0 32px 0 30px;
			margin-right: 25px;
			background: #FAF9FC;
			
			label {
				font-size: 14px;
				color: #666;
			}
			
			div {
				font-size: 24px;
				font-weight: bold;
			}
		}
	}
</style>
